/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

import { window } from './window';

const chinaTLD = '.cn';
const hostname = window.document.location.hostname;
export const isChinaFxA =
  hostname.lastIndexOf(chinaTLD) + chinaTLD.length === hostname.length;
